module.exports = __webpack_public_path__ + "media/images/pc/stores/fuji/fuji_concept_04-681f04f13ce6db497c2e953af5ef289e.jpg";